import { fetchProfile } from "@/api/index";
import { fetchDashboard } from "@/api/providerDashboard";
import managementStoreCore from "@shared/createManagementStoreCore.cjs";

const actions = {
  ...managementStoreCore.createManagementActions({ location: window.location }),

  getAccountInfo({ commit, dispatch }) {
    fetchProfile()
      .then((res) => {
        if (res.data.status === 200) {
          commit("SET_USER_INFO", res.data.data);
        } else {
          dispatch("LOGOUT");
        }
      })
      .catch(() => {
        dispatch("LOGOUT");
      });
  },

  getDashboardCounts({ commit }) {
    fetchDashboard()
      .then((res) => {
        if (res.data.status === 200) {
          commit("SET_DASHBOARD_COUNTS", res.data.data);
        }
      })
      .catch(() => {});
  },
};

export default actions;
